import React from 'react';
import { useInputHelper } from 'framework/form';
import { getWithThousandsSeparator } from 'framework/utils';
import { get } from 'lodash';
import { CURRENCIES } from 'framework/ui/field';
import Box from '@mui/material/Box';
import { Typography } from '@mui/material';
import type { SxProps, Theme } from '@mui/material';

const purchaseListTotalSx: SxProps<Theme> = theme => ({
  fontWeight: 600,

  [theme.breakpoints.up('smallMobile')]: {
    display: 'flex',
    position: 'absolute',
    bottom: '65px',
    right: 0,
    left: 0,
    marginRight: '46px',
    marginLeft: '-16px',

    '& > *': {
      width: '25%',
      paddingLeft: '16px',
      position: 'relative',

      '&:last-child': {
        marginRight: 0,
      },
    },

    '& .purchase-list-total-label': {
      display: 'none',
    },
  },

  [theme.breakpoints.down('smallMobile')]: {
    marginBottom: '20px',

    '& .purchase-list-total-title': {
      display: 'none',
    },
  },
});

const getTotal = (data: any[]) =>
  data.reduce((acc: number, item: any) => {
    const amount = get(item, 'cost.amount') || 0;
    const quantity = get(item, 'quantity') || 1;

    return +acc + +quantity * amount;
  }, 0);

const PurchaseListInputTotal = ({
  purchasesSource,
  currencySource,
}: {
  purchasesSource: string;
  currencySource: string;
}) => {
  const { getValue: getPurchases } = useInputHelper({
    source: purchasesSource,
  });
  const { getValue: getCurrency } = useInputHelper({
    source: currencySource,
  });
  const purchases = (getPurchases() as any) || [];
  const currency = getCurrency() as any;
  const total = getTotal(purchases);

  return (
    <Box sx={purchaseListTotalSx}>
      <Typography variant="subtitle1" component="span" className="purchase-list-total-title">
        Total:
      </Typography>
      <div />
      <div />
      <div>
        <Typography variant="subtitle1" component="span" className="purchase-list-total-label">
          Total:{' '}
        </Typography>
        {getWithThousandsSeparator(total || 0)}
        {currency ? CURRENCIES[currency] : ''}
      </div>
    </Box>
  );
};

export default PurchaseListInputTotal;
